/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VignetteResubmissionDto } from '../../models/vignette-resubmission-dto';

export interface VignetteUpdate$Params {

/**
 * the id of the vignette
 */
  id: string;

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;
      body: VignetteResubmissionDto
}

export function vignetteUpdate(http: HttpClient, rootUrl: string, params: VignetteUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, vignetteUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('customerGUID', params.customerGUID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

vignetteUpdate.PATH = '/vignette/{id}';
